/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { CarrotTheme, Container, FlexContainer, H4, useBreakpointComponent } from "@carrotfertility/carotene"

const ContentFade = (): JSX.Element => {
  const Fade = (
    <div
      style={{
        position: "absolute",
        top: "450px",
        left: "0",
        background: "linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%)",
        transform: "rotate(-180deg)",
        height: "50px",
        width: "calc(100% - 100px)"
      }}
    />
  )
  return useBreakpointComponent([null, null, null, Fade]) || <></>
}

export const Frame = ({
  topGreyHeaderText,
  menu,
  children
}: {
  topGreyHeaderText: string
  menu: JSX.Element
  children: JSX.Element
}): JSX.Element => {
  return (
    <FlexContainer direction="column">
      <FlexContainer
        justifyContent="space-between"
        paddingLeftRight={["small", "small", "medium", "medium"]}
        paddingTopBottom={["tiny", "tiny", "medium", "medium"]}
        alignItems="center"
      >
        <Container>
          <H4 paddingLeftRight={[null, null, "medium", "medium"]} sx={{ color: "black40" }}>
            {topGreyHeaderText}
          </H4>
        </Container>
        {menu}
      </FlexContainer>
      <Container
        sx={{ position: "relative", overflowY: "hidden", paddingTop: (theme: CarrotTheme) => `${theme.space.small}` }}
      >
        <Container
          paddingLeftRight={["small", "small", "huge"]}
          height={[null, null, "488px", "488px"]}
          sx={{ overflowY: "auto" }}
        >
          <FlexContainer gap="large" direction="column" maxWidth="600px">
            {children}
          </FlexContainer>
        </Container>
        <ContentFade />
      </Container>
    </FlexContainer>
  )
}
